export default __webpack_public_path__ + "static/project-slide-5-768-700-1eb9ec6448704ed2905b8e39fe4c4bb2.webp";